/**
 * Single source of truth for backend URL.
 *
 * Production scenarios this handles:
 *   1. `REACT_APP_BACKEND_URL` set at build time (e.g., "https://api.example.com")
 *      → API_BASE = "https://api.example.com/api"
 *   2. `REACT_APP_BACKEND_URL` NOT set at build time (very common on EC2)
 *      → API_BASE = "/api"  (works perfectly with the nginx proxy:
 *        `location /api { proxy_pass http://127.0.0.1:8000; }`)
 *   3. `REACT_APP_BACKEND_URL` accidentally set to "undefined" string
 *      → falls through to relative "/api"
 *   4. Trailing slash in env var ("https://api.example.com/")
 *      → stripped, so we don't get "//api"
 */

const raw = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BACKEND_URL) || '';

// Sanitize: trim, strip trailing slashes, reject the literal string "undefined" / "null"
let cleaned = String(raw).trim();
if (cleaned === 'undefined' || cleaned === 'null') cleaned = '';
cleaned = cleaned.replace(/\/+$/, '');

function isLocalDevHost() {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1';
}

// Local dev: call FastAPI directly (reliable even when webpack proxy or .env is misconfigured)
if (!cleaned) {
    if (isLocalDevHost()) {
        cleaned = 'http://127.0.0.1:8001';
    } else if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
        cleaned = 'http://127.0.0.1:8001';
    }
}

export const BACKEND_URL = cleaned;            // e.g. "" (relative) or "https://api.example.com"
export const API_BASE = `${BACKEND_URL}/api`;  // e.g. "/api" or "https://api.example.com/api"
export const ADMIN_API_BASE = `${BACKEND_URL}/api/admin`;

// One-time boot log so production diagnostics are easy:
if (typeof window !== 'undefined' && !window.__API_BASE_LOGGED__) {
    // eslint-disable-next-line no-console
    console.info('[config] API_BASE =', API_BASE);
    window.__API_BASE_LOGGED__ = true;
}
